if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        if (this.tabs.length === 0) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        // En el editor, al pulsar una categoría se abre su pestaña
        this.onBlockSelect = (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index !== -1) this.select(index);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      select(index, moveFocus = false) {
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });

        const tab = this.tabs[index];
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        if (moveFocus) tab.focus();
      }

      onKeydown(event, index) {
        const last = this.tabs.length - 1;
        let next;
        if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
        else if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = last;
        else return;

        event.preventDefault();
        this.select(next, true);
      }
    }
  );
}
